import { render } from "./StudentAttendance.vue?vue&type=template&id=1e12e40c&ts=true"
import script from "./StudentAttendance.vue?vue&type=script&lang=ts"
export * from "./StudentAttendance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__